import { RefObject, useEffect, useState } from "react";

export const MIN_DROPDOWN_MENU_HEIGHT = 50;

export function useMaxMenuHeight(
  elementRef: RefObject<HTMLElement>,
  isActive: boolean = true,
  defaultHeight = 400,
  bottomMargin: number = 40,
  minimumHeight: number = MIN_DROPDOWN_MENU_HEIGHT
) {
  const [maxMenuHeight, setMaxMenuHeight] = useState<number>(defaultHeight);

  useEffect(() => {
    function updateMaxMenuHeight() {
      if (isActive && elementRef.current) {
        const buttonRect = elementRef.current.getBoundingClientRect();
        const spaceBelow = window.innerHeight - buttonRect.bottom - bottomMargin;
        setMaxMenuHeight(Math.max(spaceBelow, minimumHeight));
      }
    }

    updateMaxMenuHeight();
    window.addEventListener('resize', updateMaxMenuHeight);
    window.addEventListener('scroll', updateMaxMenuHeight, true);

    return () => {
      window.removeEventListener('resize', updateMaxMenuHeight);
      window.removeEventListener('scroll', updateMaxMenuHeight, true);
    };
  }, [elementRef, isActive]);

  return maxMenuHeight;
}